// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1307":"a5b049a5b24e6a9c","3108":"b9b9c124d4341f2d"}[chunkId] + ".css";
};